import React from 'react'
import { Box } from '@mui/material'
// eslint-disable-next-line import/no-extraneous-dependencies
import { SxProps } from '@mui/system'

const Support: (prop: {
  sx?: SxProps
  className?: string | null
}) => JSX.Element = (prop: {
  sx?: SxProps | null
  className?: string | null
}) => {
  const { sx, className } = prop
  return (
    <Box sx={sx || {}} className={className || ''}>
      <svg
        className="w-full"
        width="24px"
        height="23px"
        viewBox="0 0 24 23"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="currentColor">
            <path
              fill="currentColor"
              d="M12,0 C16.8503559,0 20.7952645,3.86470097 20.9346074,8.68082095 L20.9384164,8.94444444 L20.9384164,17.6333333 C20.9384164,20.2406093 18.8819998,22.3709071 16.2985833,22.4841538 L16.0821114,22.4888889 L12.1707296,22.4888889 L12.1707296,20.9555556 L16.0821114,20.9555556 C17.8441027,20.9555556 19.287347,19.5707742 19.384786,17.8220435 L19.3900293,17.6333333 L19.3900293,8.94444444 C19.3900293,4.84945184 16.0794074,1.53333333 12,1.53333333 C8.00218077,1.53333333 4.74270307,4.71813355 4.61392309,8.69969984 L4.60997067,8.94444444 L4.60997067,16.1 L3.06158358,16.1 L3.06158358,8.94444444 C3.06158358,4.00651314 7.0614558,0 12,0 Z"
              fillRule="nonzero"
            />
            <path
              d="M3.83577713,8.17777778 L0.774193548,8.17777778 C0.346618258,8.17777778 0,8.52102614 0,8.94444444 L0,15.5888889 C0,16.0123072 0.346618258,16.3555556 0.774193548,16.3555556 L3.83577713,16.3555556 C4.26335242,16.3555556 4.60997067,16.0123072 4.60997067,15.5888889 L4.60997067,8.94444444 C4.60997067,8.52102614 4.26335242,8.17777778 3.83577713,8.17777778 Z M3.06119648,9.7105303 L3.06119648,14.8221758 L1.54775367,14.8221758 L1.54775367,9.7105303 L3.06119648,9.7105303 Z"
              fillRule="nonzero"
            />
            <path
              d="M23.2258065,8.68888889 L20.1642229,8.68888889 C19.7366476,8.68888889 19.3900293,9.03213725 19.3900293,9.45555556 L19.3900293,16.1 C19.3900293,16.5234183 19.7366476,16.8666667 20.1642229,16.8666667 L23.2258065,16.8666667 C23.6533817,16.8666667 24,16.5234183 24,16.1 L24,9.45555556 C24,9.03213725 23.6533817,8.68888889 23.2258065,8.68888889 Z M22.4512258,10.221897 L22.4512258,15.3325318 L20.937783,15.3325318 L20.937783,10.221897 L22.4512258,10.221897 Z"
              fillRule="nonzero"
              transform="translate(21.695015, 12.777778) scale(-1, 1) translate(-21.695015, -12.777778) "
            />
            <rect
              x="9.95894428"
              y="20.4444444"
              width="3.57184751"
              height="2.55555556"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default Support
